'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | Thursday 5 December 2019
 * `en-us` | Thursday, December 5, 2019
 * `es` | jueves, 5 de diciembre de 2019
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/date_format_new/date_with_weekday/name
 */
var form = 'date_with_weekday';
lingojsCore.registerDynamicTags(lingojsCore.t('date_format_new', form, 'name'));

module.exports = form;
//# sourceMappingURL=index.js.map
